import { Component } from '@angular/core';

import { filterRows } from '../../function/filter-rows.function';
import { currentMainState } from '../../game-plan.state';
import { TranslationKeyMap } from '../../gp-main.i18n';
import { MainState } from '../../model/main-state.model';
import { ViewPersonaFilterOption } from '../../model/view-persona-filter-option.model';

@Component({
    selector: 'cmps-gp-filter',
    templateUrl: './filter.component.html',
})
export class FilterComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _state: MainState;

    constructor() {
        this._state = currentMainState();
    }

    /** @private */
    _onPersonaChange(option: ViewPersonaFilterOption): void {
        this._state.selectedPersonaFilterOptions ??= new Set();

        const opts = this._state.selectedPersonaFilterOptions;
        if (opts?.has(option.personaType)) {
            opts.delete(option.personaType);
        } else {
            opts.add(option.personaType);
        }
        filterRows();
    }

    /** @private */
    _onClearPersonasClick(): void {
        this._state.selectedPersonaFilterOptions?.clear();
        filterRows();
    }
}
